import { BaseEntity } from '~/app/core/models/base-entity.model';
import { Context } from '~/app/features/mgmt/context/models/context';
import { ExternalFile } from '../../../../shared/components/external-file/types';
import { ProfileAddress } from './profile-address';
import { ProfileEmployeeInfo } from './profile-employee-info';
import { ProfilePassword } from './profile-password';

export class Profile extends BaseEntity<Profile> {
  address: ProfileAddress = new ProfileAddress();
  employeeInformation: ProfileEmployeeInfo = new ProfileEmployeeInfo();
  password: ProfilePassword = new ProfilePassword();
  firstname?: string;
  lastname?: string;
  email?: string;
  username?: string;
  phone?: string;
  picture?: {
    id?: string;
  };
  profilePicture?: ExternalFile | null;
  contexts: Array<Context> = [];
  public override deserialize(object: this): this {
    object.address = object.address ? new ProfileAddress().deserialize(object.address) : object.address;
    object.employeeInformation = object.employeeInformation
      ? new ProfileEmployeeInfo().deserialize(object.employeeInformation)
      : object.employeeInformation;
    return super.deserialize(object);
  }
}
